export default {
  getMonthThai (m) {
    let monthThai = ''
    switch (m) {
      case '01':
        monthThai = 'มกราคม'
        break
      case '02':
        monthThai = 'กุมภาพันธ์'
        break
      case '03':
        monthThai = 'มีนาคม'
        break
      case '04':
        monthThai = 'เมษายน'
        break
      case '05':
        monthThai = 'พฤษภาคม'
        break
      case '06':
        monthThai = 'มิถุนายน'
        break
      case '07':
        monthThai = 'กรกฎาคม'
        break
      case '08':
        monthThai = 'สิงหาคม'
        break
      case '09':
        monthThai = 'กันยายน'
        break
      case '10':
        monthThai = 'ตุลาคม'
        break
      case '11':
        monthThai = 'พฤศจิกายน'
        break
      case '12':
        monthThai = 'ธันวาคม'
        break
    }
    return monthThai
  },
  getMThai (m) {
    let monthThai = ''
    switch (m) {
      case '01':
        monthThai = 'ม.ค.'
        break
      case '02':
        monthThai = 'ก.พ.'
        break
      case '03':
        monthThai = 'มี.ค.'
        break
      case '04':
        monthThai = 'เม.ย.'
        break
      case '05':
        monthThai = 'พ.ค.'
        break
      case '06':
        monthThai = 'มิ.ย.'
        break
      case '07':
        monthThai = 'ก.ค.'
        break
      case '08':
        monthThai = 'ส.ค.'
        break
      case '09':
        monthThai = 'ก.ย.'
        break
      case '10':
        monthThai = 'ต.ค.'
        break
      case '11':
        monthThai = 'พ.ย.'
        break
      case '12':
        monthThai = 'ธ.ค.'
        break
    }
    return monthThai
  },
  showDateThai (value) {
    let val2 = value + ''
    let year = val2.substring(2, 4)
    let month = val2.substring(4, 6)
    let day = val2.substring(6, 8)
    let dateShow = day + ' ' + this.getMThai(month) + ' ' + year
    return dateShow
  },
  formatNumber (value) {
    var intPartFormat = value.toString()
    if ((value === '') || (value.length < 3)) {
      return intPartFormat
    } else {
      // console.log('value = ' + value)
      var intPart = parseInt(value).toFixed(0)
      // console.log('intPart = ' + intPart)
      intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    }
    // console.log('intPartFormat = ' + intPartFormat)
    return intPartFormat
  },
  formatRatio (value) {
    let val = value
    let val2 = value
    let returnVal = 0
    val2 = val2.toString()
    if (val2.length > 1) {
      let val2Array = val2.split('.')
      // console.log('val2Array = ', val2Array)
      if (val2Array.length === 1) {
        returnVal = val2Array[0]
      } else {
        let val3 = val2Array[1]
        // let lastVal2 = val3.toString().substring(2, 3)
        // console.log('lastVal2 = ', lastVal2)
        // if (parseInt(lastVal2) >= 5) {
        //   let plushVal = val3.toString().substring(0, 2)
        //   if (plushVal === '00') {
        //     val3 = '01'
        //   } else {
        //     val3 = parseInt(plushVal) + 1
        //   }
        // }
        val3 = val3.toString().substring(0, 2)
        // console.log('val3 = ', val3)
        returnVal = val2Array[0] + '.' + val3
      }
    } else {
      returnVal = val
    }
    return returnVal
  }
}
